import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { Popup, SouthEast } from '../../utils/popups';
import { ScrollableContainer } from '../ScrollableContainer';
import { TextButton } from '../TextButton';
import { AbstractPopup, DismissalReason, } from './AbstractPopup';
export function UtilityPopup({ children, reject, ...props }) {
    return (_jsx(UtilityPopupRoot, { reject: reject, translateFn: SouthEast, ...props, children: _jsxs(Content, { children: [_jsx(Header, { children: _jsx(TextButton, { type: "button", onClick: () => {
                            reject(DismissalReason.CloseButton);
                        }, children: "Done" }) }), _jsx(ScrollableContainer, { children: _jsx(Body, { children: children }) })] }) }));
}
const Header = styled.div `
    padding: 1.5rem;
`;
const Body = styled.div `
    padding: 0 1.5rem;
`;
const Content = styled.div `
    display: grid;
    grid-template-rows: auto 1fr;
    height: var(--vh-100, 100vh);
    box-sizing: border-box;
    padding-bottom: 1.5rem;

    @media (min-width: 32.5rem) {
        height: 48rem;
        max-height: calc(var(--vh-100, 100vh) - 2rem);
    }
`;
const UtilityPopupRoot = styled(AbstractPopup) `
    --Popup_X: 0;
    --Popup_Y: 0;

    --Popup_Padding: 0;

    --Popup_Width: var(--vw-100, 100vw);

    --Popup_Border: 0;
    --Popup_BoxShadow: none;

    @media (min-width: 32.5rem) {
        --Popup_InitialScale: 0.98;
        --Popup_BorderRadius: 2rem;
        --Popup_Left: 50%;
        --Popup_Top: 50%;
        --Popup_X: -50%;
        --Popup_Y: -50%;
        --Popup_InitialOffsetY: 1rem;
        --Popup_OffsetY: 0;

        --Popup_Width: 23.75rem;

        --Popup_Border: initial;
        --Popup_BoxShadow: initial;

        /* Offset transitions */
        --Popup_OffsetTransition: initial;
    }

    @media (min-width: 60rem) {
        --Popup_InitialOffsetX: -100%;
        --Popup_InitialOffsetY: 0;
        --Popup_OffsetY: -100%;

        --Popup_Left: 0;
        --Popup_Top: 0;
        --Popup_X: var(--Popup_AnchorX, 0);
        --Popup_Y: max(calc(100% + 1rem), var(--Popup_AnchorY, 0));
    }
`;
export const settingsPopup = Popup.create(UtilityPopup);
